<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <h2 class="mb-4">Percentages</h2>
      <p class="mb-4">
        Most of us are first introduced to percentages in primary school in terms of grades. When we
        start earning our own money, we see a percent of the cost of our purchases being added as
        tax. A percentage is really just a number expressed as a fraction with a denominator of 100.
        For instance, 76% is equal to 76/100, or if we convert the fraction into decimal form, 0.76.
      </p>

      <p class="mb-4">Convert each of the following percentages into decimal form.</p>

      <p class="mb-2 pl-6">a) <number-value :value="pct1" unit="\%" /></p>

      <calculation-input
        v-model="inputs.decA"
        class="mb-6 pl-6"
        :prepend-text="'$\\text{Number:}$'"
        :disabled="!allowEditing"
      />

      <p class="mb-2 pl-6">b) <number-value :value="pct2" unit="\%" /></p>

      <calculation-input
        v-model="inputs.decB"
        class="mb-6 pl-6"
        :prepend-text="'$\\text{Number:}$'"
        :disabled="!allowEditing"
      />

      <p class="mb-2 pl-6">c) <number-value :value="pct3" unit="\%" /></p>

      <calculation-input
        v-model="inputs.decC"
        class="mb-6 pl-6"
        :prepend-text="'$\\text{Number:}$'"
        :disabled="!allowEditing"
      />

      <p class="mb-4">Convert each of the following decimal numbers into percent form.</p>

      <p class="mb-2 pl-6">d) <number-value :value="dec1" /></p>

      <calculation-input
        v-model="inputs.pctD"
        class="mb-6 pl-6"
        :prepend-text="'$\\text{Percentage:}$'"
        :append-text="'$\\%$'"
        :disabled="!allowEditing"
      />

      <p class="mb-2 pl-6">b) <number-value :value="dec2" /></p>

      <calculation-input
        v-model="inputs.pctE"
        class="mb-6 pl-6"
        :prepend-text="'$\\text{Percentage:}$'"
        :append-text="'$\\%$'"
        :disabled="!allowEditing"
      />

      <p class="mb-2 pl-6">c) <number-value :value="dec3" /></p>

      <calculation-input
        v-model="inputs.pctF"
        class="mb-6 pl-6"
        :prepend-text="'$\\text{Percentage:}$'"
        :append-text="'$\\%$'"
        :disabled="!allowEditing"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '../inputs/CalculationInput';
import NumberValue from '../NumberValue';

export default {
  name: 'Question346',
  components: {
    CalculationInput,
    NumberValue,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      // Put a list of inputs or computed properties here to be sent for marking
      inputs: {
        decA: null,
        decB: null,
        decC: null,
        pctD: null,
        pctE: null,
        pctF: null,
      },
    };
  },
  computed: {
    pct1() {
      return this.taskState.getValueBySymbol('pct1').content;
    },
    pct2() {
      return this.taskState.getValueBySymbol('pct2').content;
    },
    pct3() {
      return this.taskState.getValueBySymbol('pct3').content;
    },
    dec1() {
      return this.taskState.getValueBySymbol('dec1').content;
    },
    dec2() {
      return this.taskState.getValueBySymbol('dec2').content;
    },
    dec3() {
      return this.taskState.getValueBySymbol('dec3').content;
    },
  },
};
</script>
